import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PendingChangesSaveStatusState } from 'src/app/utils/pending-changes-save-status';

@Component({
  selector: 'app-pending-changes-save-status',
  templateUrl: './pending-changes-save-status.component.html',
  styleUrl: './pending-changes-save-status.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule],
  host: {
    '[class.pending-changes-save-status-host--hidden]': '!should_be_shown()',
  },
})
export class PendingChangesSaveStatusComponent {
  readonly status_state = input.required<PendingChangesSaveStatusState>();
  readonly tooltip = input<string | null>(null);
  readonly show_when_label_empty = input<boolean>(false);
  readonly label_max_width = input<string | null>(null);

  readonly label = computed<string>(() => this.status_state().label());
  readonly should_be_shown = computed<boolean>(() => this.show_when_label_empty() || this.label() !== '');
  readonly tooltip_value = computed<string>(() => this.tooltip() ?? '');
  readonly has_tooltip = computed<boolean>(() => this.tooltip_value().trim().length > 0);
}
